import { ArrowRight, MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/config";
import LiveSocialProof from "@/components/LiveSocialProof";
import { BookingChoice } from "@/components/BookingChoice";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e65e354b-d9a2-449a-9e1d-ca9880f3773c/images/54bf2e03a5cc5a81630392c014bc8de7527c46e35c58560a321f57953622ae66.png";

export default function Hero({ onOpenChat }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Cabelo saudável e brilhante"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 w-full">
        <div className="max-w-2xl animate-fade-up">
          <div className="mb-6">
            <LiveSocialProof variant="hero" />
          </div>

          <span data-testid="hero-overline" className="overline">
            EZ Capelli Studio • Beleza Real
          </span>

          <h1
            data-testid="hero-title"
            className="font-heading text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] mt-6 text-white"
          >
            Transforme seu <br />
            <span className="gold-gradient-text italic">cabelo</span> e sua{" "}
            <span className="gold-gradient-text italic">autoestima</span>.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="text-base md:text-lg leading-relaxed text-white/75 font-light mt-8 max-w-xl"
          >
            Especialista em tratamento capilar e transformação dos fios. Fios
            saudáveis, brilhantes e uma experiência que começa no olhar —
            termina no espelho.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <BookingChoice onOpenChat={onOpenChat} />
            <a
              data-testid="hero-whatsapp-btn"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-gold animate-pulse-gold"
            >
              <MessageCircle size={18} strokeWidth={1.5} />
              Agendar pelo WhatsApp
              <ArrowRight size={16} strokeWidth={1.5} />
            </a>
            <a
              data-testid="hero-services-btn"
              href="#servicos"
              className="btn-secondary-outline"
            >
              Ver serviços
            </a>
          </div>

          <div className="mt-16 flex items-center gap-8 text-white/60 text-sm">
            <div data-testid="hero-stat-clients">
              <div className="font-heading text-3xl text-[#D4AF37] font-light">500+</div>
              <div className="text-xs tracking-wider uppercase">Clientes</div>
            </div>
            <div className="w-px h-10 bg-white/15" />
            <div data-testid="hero-stat-years">
              <div className="font-heading text-3xl text-[#D4AF37] font-light">10</div>
              <div className="text-xs tracking-wider uppercase">Anos de expertise</div>
            </div>
            <div className="w-px h-10 bg-white/15" />
            <div data-testid="hero-stat-rating">
              <div className="font-heading text-3xl text-[#D4AF37] font-light">5.0★</div>
              <div className="text-xs tracking-wider uppercase">Avaliação</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#D4AF37]/60 text-xs tracking-[0.3em] uppercase animate-pulse hidden md:block">
        Role para explorar ↓
      </div>
    </section>
  );
}
